import React from "react";
import {Hint} from "react-autocomplete-hint";

type Props = {
    text: string | undefined;
    onChange: (value: string) => void;
    options: any;
};

function HintInput({options = [], text, onChange}: Props) {
    //@ts-ignore
    options = options.filter((opt) => opt != null);
    return (
        <div
            style={{
                width: "100%",
                display: "flex",

                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Hint allowTabFill allowEnterFill options={options ?? []}>
                <input
                    type="search"
                    placeholder="مقدار مورد نظر خود را جستجو کنید"
                    value={text}
                    onKeyDown={(e) => {
                        e.stopPropagation();
                    }}
                    onChange={(e) => onChange(e.target.value)}
                    style={{
                        outline: "none",
                        border: "0.5px solid #E1EAF5",
                        borderRadius: "4px",
                        color: "#AEAEAE",
                        padding: "5px 10px",
                        width: 310,
                        fontSize: "14px",
                    }}
                />
            </Hint>
        </div>
    );
}

export default HintInput;
